// ─── Collage Layout Utilities ─────────────────────────────────
// Safe positioning helpers for collage elements.
// Elements use relative coordinates (0–1) with safe-edge clamping.

export function getSafeLayout(layout, isMobile) {
  // Safely get the source layout, falling back to desktop or defaults
  const source = (isMobile ? layout?.mobile : layout?.desktop) 
    || layout?.desktop 
    || layout?.mobile 
    || { x: 0.5, y: 0.5, w: 0.3, z: 1 };
  const w = Math.min(1.0, Math.max(0.08, source.w ?? 0.3));
  // For full-width elements, allow x to be exactly 0.5 for edge-to-edge centering
  const xMin = w >= 0.95 ? 0.5 : 0.04;
  const xMax = w >= 0.95 ? 0.5 : 0.96;
  return {
    x: Math.min(xMax, Math.max(xMin, source.x ?? 0.5)),
    y: Math.min(0.96, Math.max(0.02, source.y ?? 0.5)),
    w,
    z: source.z || 1,
  };
}

export function getElementFrameStyle(layout, isMobile) {
  // Handle null/undefined layout
  if (!layout) {
    return {
      position: 'absolute',
      left: '50%',
      top: '50%',
      width: '30%',
      transform: 'translate(-50%, -50%)',
      zIndex: 1,
    };
  }
  const safe = getSafeLayout(layout, isMobile);
  return {
    position: 'absolute',
    left: `${safe.x * 100}%`,
    top: `${safe.y * 100}%`,
    width: `${safe.w * 100}%`,
    transform: 'translate(-50%, -50%)',
    zIndex: safe.z,
  };
}
